/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamAcceptedFileFormats200,
  GetApiV1ExamAcceptedFileFormats401,
  GetApiV1ExamAcceptedFileFormats500,
  GetApiV1ExamAcceptedFileFormatsQueryResponse,
} from "../../types/examQuestionLibraryController/GetApiV1ExamAcceptedFileFormats.ts";
import { stringStringBaseDropDownListViewModelSchema } from "../stringStringBaseDropDownListViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamAcceptedFileFormats200Schema = z.array(
  z.lazy(() => stringStringBaseDropDownListViewModelSchema),
) as unknown as ToZod<GetApiV1ExamAcceptedFileFormats200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamAcceptedFileFormats401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamAcceptedFileFormats401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamAcceptedFileFormats500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamAcceptedFileFormats500>;

export const getApiV1ExamAcceptedFileFormatsQueryResponseSchema = z.lazy(
  () => getApiV1ExamAcceptedFileFormats200Schema,
) as unknown as ToZod<GetApiV1ExamAcceptedFileFormatsQueryResponse>;
